import React from 'react'

export default function CloseIcon({outline, className}) {
    return (
        <div className={className}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                {
                    outline && <circle cx="12" cy="12" r="12" fill="white" />
                }
                <path
                    d="M5.11394 5.23538L5.1702 5.1702C5.37651 4.9639 5.69935 4.94514 5.92685 5.11394L5.99202 5.1702L11.8812 11.0599L17.7714 5.1702C17.9984 4.94327 18.3663 4.94327 18.5933 5.1702C18.8202 5.39714 18.8202 5.76508 18.5933 5.99202L12.7032 11.8812L18.5933 17.7714C18.7996 17.9777 18.8183 18.3006 18.6495 18.5281L18.5933 18.5933C18.3869 18.7996 18.0641 18.8183 17.8366 18.6495L17.7714 18.5933L11.8812 12.7032L5.99202 18.5933C5.76508 18.8202 5.39714 18.8202 5.1702 18.5933C4.94327 18.3663 4.94327 17.9984 5.1702 17.7714L11.0599 11.8812L5.1702 5.99202C4.9639 5.78572 4.94514 5.46288 5.11394 5.23538L5.1702 5.1702L5.11394 5.23538Z"
                    fill="#a9a9a9"
                />
            </svg>
        </div>
    )
}

CloseIcon.displayName = 'CloseIcon'
